export default __webpack_public_path__ + "static/media/asusd.8d5a66c2.svg";